export const NO_RESULTS_FOUND_MSG = {
    message: 'No Results Found',
};
